import React, { useState } from 'react'
import styled from 'styled-components'
import { Link, StaticQuery, graphql } from 'gatsby'
import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import Hamburger from 'react-ionicons/lib/MdMenu'
import logo from '../img/logo.png'
import slugify from '../utils/slugify'

const StyledNav = styled.div`
  #logo {
    img {
      max-width: 120px;
      @media(min-width: ${({ theme }) => theme.breakpoints.sm}) {
        max-width: 150px;
      }
    }
    a {
      text-transform: capitalize;
    }
  }
/* h1 {
      font-size: 50px;
      vertical-align: text-bottom;
      line-height: 1;
      color: ${({ theme }) => theme.colors.main};
    }
    span {
      display: block;
      font-size: 14px;
      font-style: italic;
      background-color: ${({ theme }) => theme.colors.main};
      color: #fff;
      padding: 2px 6px;
      transform: skew(-6deg);
    }  */
`

const dienstenQuery = graphql`
  query dienstenQuery {
    allContentfulCategorie {
      nodes {
        naam
        contentful_id
      }
    }
  }
`

const Navigation = () => {
  const [open, setOpen] = useState(false)
  return (
    <StyledNav className="sticky-top light shadow-sm bg-white">
      <Navbar expand="md">
        <Container>
          <div id="logo" className="navbar-brand">
            <Link to="/">
              {/* <h1>Isis</h1> */}
              <img src={logo} alt="logo Isis schoonheidsinstituut" className="img-fluid" />
              {/* <span>schoonheidsinstituut</span> */}
            </Link>
          </div>
          <NavbarToggler onClick={() => setOpen(!open)}>
            <Hamburger />
          </NavbarToggler>
          <Collapse isOpen={open} navbar>
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  Diensten
                </DropdownToggle>
                <DropdownMenu right>
                  <StaticQuery
                    query={dienstenQuery}
                    render={data =>
                      data.allContentfulCategorie.nodes.map(dienst => (
                        <Link key={dienst.contentful_id} to={`/diensten/${slugify(dienst.naam)}`}>
                          <DropdownItem>{dienst.naam}</DropdownItem>
                        </Link>
                      ))
                    }
                  />
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <Link to="/contact" className="nav-link">
                  Contact
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/cadeaubon" className="nav-link">
                  Cadeaubon
                </Link>
              </NavItem>
              <NavItem>
                <a
                  href="https://be.babor.com/institute/schoonheidsinstituut-isis"
                  className="nav-link"
                  target="blank"
                  rel="noopener noreferrer"
                >
                  Webshop
                </a>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </StyledNav>
  )
}

export default Navigation
